<template>
  <div id="SignUp" class="d-flex justify-content-center align-items-center">
    <div class="container-login text-center">
      <img src="/assets/img/logo-white.png" alt="" class="mb--lg-5 mb-4 logo-login" />
      <h1 class="txt-title mb-sm-3 mb-2 fs-sm-4 fs-4">{{ signupUI.title }}</h1>
      <!-- <p class="fs-sm-5 fs-6" v-if="getLang == 'indo' ">Hanya dengan satu langkah lagi! Kamu bisa bergabung dengan kami!</p> -->
      <!-- <p class="fs-sm-5 fs-6" v-if="getLang == 'uk' ">Only one step! Join with us and enjoy the benefit.</p> -->
      <form @submit.prevent="onSubmitSignUp" class="form mb-4">
        <div class="form-row">
          <div class="col-md-6 py-2">
            <input v-model="data.name" type="text" name="full-name" class="form-control bg-white" :placeholder="signupUI.form.fullName" required>
          </div>
          <div class="col-md-6 py-2">
            <input v-model="data.email" type="email" name="email" class="form-control bg-white" :placeholder="signupUI.form.email" required>
          </div>
        </div>
        <div class="form-group pt-2">
          <div>
            <vue-phone-number-input v-model="vuePhone.phone" v-bind="vuePhone.props" @update="onUpdate"></vue-phone-number-input>
          </div>
        </div>
        <div class="form-group">
          <input 
            v-model="data.referral_code" 
            type="text" 
            name="referral" 
            class="form-control bg-white" 
            :placeholder="signupUI.form.referral"
            :readonly="!!$route.query.referral"
          >
        </div>
        <div class="form-row">
          <div class="position-relative col-md-6 form-group d-flex align-items-center">
            <input v-model="data.password" :type="passwordType" name="password" class="form-control bg-white" :placeholder="signupUI.form.password" required>
            <div class="position-absolute p-2" style="right:4px">
              <i v-if="passwordType === 'password'" class="fas fa-eye-slash text-secondary" @click="passwordType = 'text'"></i>
              <i v-if="passwordType === 'text'" class="fas fa-eye text-secondary" @click="passwordType = 'password'"></i>
            </div>
          </div>
          <div class="position-relative col-md-6 form-group d-flex align-items-center">
            <input v-model="data.confirm_password" :type="confirmPassType" name="confirm-password" class="form-control bg-white" :placeholder="signupUI.form.confirmPassword" required>
            <div class="position-absolute p-2" style="right:4px">
              <i v-if="confirmPassType === 'password'" class="fas fa-eye-slash text-small text-secondary" @click="confirmPassType = 'text'"></i>
              <i v-if="confirmPassType === 'text'" class="fas fa-eye text-small text-secondary" @click="confirmPassType = 'password'"></i>
            </div>
          </div>
        </div>
        <div class="form-group">
          <select v-model="data.account_leverage" name="account_leverage" class="form-control" id="account_leverage" required>
            <option value="" selected disabled>{{ getLang === 'indo' ? config.ui.selectLeverage.indo : config.ui.selectLeverage.uk }}</option>
            <option
              v-for="option in config.leverageOptions"
              :key="option.value"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <select v-model="data.account_type" name="account-type" class="form-control" id="account-type" required>
            <option value="" selected disabled>{{ getLang === 'indo' ? config.ui.selectAccountType.indo : config.ui.selectAccountType.uk }}</option>
            <option
              v-for="(accountType, key) in config.accountTypes"
              :key="key"
              :value="accountType.id"
            >
              {{ accountType.name }}
            </option>
          </select>
        </div>
        <div class="form-check">
          <input name="terms" class="form-check-input" type="checkbox" value="" id="inlineCheckbox1" required style="width:auto">
          <label class="form-check-label" for="terms">
            <a target="_blank" href='https://secure.socrateslegacy.com/assets/legal/Socrates-Legal-Documents.pdf'>
              {{ signupUI.form.terms }}
            </a>
          </label>
        </div>
        <!-- <router-link to="/dashboard"> -->
        <button type="submit" :disabled="isLoading" class="btn btn-blue txt-bold px-5 mt-3 mx-auto text-center d-flex align-items-center">
          {{ signupUI.form.register }} &nbsp;
          <div v-if="isLoading" class="pl-2 text-light" role="status">
            <span class="sr-only">Loading...</span>
             <i class="fas fa-spinner fa-spin"></i>
          </div>
        </button>
        <!-- </router-link> -->
      </form>
      <div class="extra">
        <p v-if="getLang == 'indo' ">
          {{ signupUI.links.haveAccount.indo }}
          <a
            href="/"
            target="_blank"
            class="txt-bold text-white"
            >{{ signupUI.links.login }}</a
          >
        </p>
        <p v-if="getLang == 'uk' ">
          {{ signupUI.links.haveAccount.uk }}
          <a
            href="/"
            class="txt-bold text-white"
            >{{ signupUI.links.login }}</a
          >
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Swal from "sweetalert2";
import { AppConstants, ApiConfig, AccountTypes, SignupUI } from "../const";

const userData = JSON.parse(localStorage.getItem("userData"));

export default {
  name: "SignUp",
  data() {
    return {
      isLoading: false,
      getLang: 'uk',
      passwordType: 'password',
      confirmPassType: `password`,
      intPhone: ``,
      countryCode: ``,
      config: AppConstants.realAccounts,
      signupUI: SignupUI,
      data: {
        name: ``,
        email: ``,
        referral_code: ``,
        password: ``,
        confirm_password: ``,
        account_leverage: ``,
        account_type: ``
      },
      vuePhone: {
        phone: "",
        props: {
          clearable: true,
          fetchCountry: true,
          preferredCountries: ["US"],
          noExample: false,
          required: true,
          class: `input-phone`,
          translations: {
            countrySelectorLabel: "Code",
            countrySelectorError: "Error",
            phoneNumberLabel: "Your phone",
            example: "Ex.:"
          }
        }
      }
    };
  },
  mounted() {
    // Ambil referral code dari URL query parameter
    const referralFromUrl = this.$route.query.referral;
    if (referralFromUrl) {
      this.data.referral_code = referralFromUrl;
    }

    if (userData && userData.token) {
      var config = {
        method: "get",
        url: `${ApiConfig.url}/me/accounts`,
        headers: {
          "content-type": "application/json",
          "x-app-token": ApiConfig.token,
          "x-user-token": userData.token,
        },
      };

      axios(config)
        .then(function (res) {
          console.log("success get data: ", res.data.data);
          if (res.data.statusCode == 200) {
            window.location.href = "/dashboard";
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  },
  methods: {
    onUpdate(payload) {
      let data = payload
      this.intPhone = data?.formatInternational
      this.countryCode = data?.countryCode
    },
    onSubmitSignUp() {
      let val = this.data

      const dataRequest = {
        name: val.name,
        email: val.email,
        password: val.password,
        account_spec_id: val.account_type,
        account_type: AccountTypes.REAL,
        confirm_password: val.confirm_password,
        phone: this.intPhone.split(' ').join(),
        parent_ref: val.referral_code,
        account_leverage: val.account_leverage,
      }

      this.isLoading = true

      if(val.password !== val.confirm_password) {
        Swal.fire({
          title: 'Oops!',
          text: this.signupUI.messages.passwordMismatch,
          icon: 'warning'
        })

        this.isLoading = false

        return
      }

      var config = {
        method: "post",
        url: `${ApiConfig.url}/auth/register`,
        headers: {
          "content-type": "application/json",
          "x-app-token": ApiConfig.token,
        },
        params: dataRequest,
      };

      // console.log("DEBUG: dataRequest being sent to API:", dataRequest);
      // console.log("DEBUG: Full axios config:", config);

      // Comment out the axios call for debugging
      axios(config)
        .then((result) => {
          let data = result.data
          if(data.status == `SUCCESS`) {
            this.isLoading = false
            Swal.fire({
              title: this.signupUI.messages.registrationSuccess.title,
              text: this.signupUI.messages.registrationSuccess.text,
              icon: 'success'
            }).then(() => {
              this.$router.push('/')
            })
          }
        })
        .catch(function (error) {
          const errMessage = error.message;
          this.isLoading = false
          Swal.fire({
            title: 'Oops!',
            text: errMessage,
            icon: 'warning'
          })
        });

      // Stop loading for debugging
      // this.isLoading = false;
    },
  },
};
</script>